import React, { type PropsWithChildren } from 'react';

import { NavigationAnalyticsContext } from '@atlaskit/analytics-namespaced-context/NavigationAnalyticsContext';

import { COMPONENT_NAME } from './constants';
import type { PackageMetaDataType, SourceMetadataType } from './generated/analytics.types';

type AnalyticsGlobalContextType = PackageMetaDataType & {
	attributes: SourceMetadataType;
};

const packageMetadata: PackageMetaDataType = {
	source: 'topNav',
	componentName: COMPONENT_NAME,
	packageName: process.env._PACKAGE_NAME_ ?? '',
	packageVersion: process.env._PACKAGE_VERSION_ ?? '',
};

const sourceMetadata: SourceMetadataType = {
	navLayer: 'global',
	navContainer: 'top',
	navVersion: '4',
};

const contextData: AnalyticsGlobalContextType = {
	...packageMetadata,
	attributes: sourceMetadata,
};

/**
 * Adds the package and source metadata declared in `analytics.spec.yaml` to every
 * analytics event fired from within the global top navigation.
 *
 * Consumers do not render this directly — `GlobalTopNavigation` wraps itself in it.
 */
export function GlobalTopNavigationAnalyticsContext({ children }: PropsWithChildren): JSX.Element {
	return <NavigationAnalyticsContext data={contextData}>{children}</NavigationAnalyticsContext>;
}
